module.exports = __webpack_public_path__ + "61f6fc8c2d1fe885d0d09ae6f0b68a8b.png";